<template>
	<o-avatar
		root-url="/app/companylogo/"
		:tooltip="$t('common.shared.components.logoCompany.editLogo')"
		:name="company.name"
		:avatar="isClientCompany ? undefined : setup.logoUrl"
		:nb-avatar-updates="setup.ui.token"
		:update-function="setup.canUpdateLogo
			? setup.updateLogoAsync.bind(setup)
			: undefined"
		size="sm"
		square
		contain/>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedLogoCompanyEmits, SharedLogoCompanyProps } from './SharedLogoCompanySetup';
import SharedLogoCompanySetup from './SharedLogoCompanySetup';
const emits = defineEmits<SharedLogoCompanyEmits>() as SharedLogoCompanyEmits;
const props = withDefaults(defineProps<SharedLogoCompanyProps>(), SharedLogoCompanySetup.defaultProps);
const setup = new SharedLogoCompanySetup(props, emits);
// #endregion
</script>

<style scoped lang="less">
.orion-avatar {
	border-radius: 0.5rem;
}

:deep(.orion-avatar__picto) {
	transform: translate(0.5rem, 0.5rem);
}
</style>
